import {
    STOCK_TAKING_CAR_MANAGMENT_SAVE_BEGIN,
    STOCK_TAKING_CAR_MANAGMENT_SAVE_SUCCESS,
    STOCK_TAKING_CAR_MANAGMENT_SAVE_FAILURE
} from "../constants";

export function reducer(state, action){
    switch(action.type){
        case STOCK_TAKING_CAR_MANAGMENT_SAVE_BEGIN:
            return {
                takingCarManagement: {
                    ...state.takingCarManagement,
                    savePending: true,
                    saveSuccess: null,
                    saveError: null
                }
            }
        case STOCK_TAKING_CAR_MANAGMENT_SAVE_SUCCESS:
            return {
                takingCarManagement: {
                    ...state.takingCarManagement,
                    savePending: false,
                    saveSuccess: action.data,
                    saveError: null
                }
            }
        case STOCK_TAKING_CAR_MANAGMENT_SAVE_FAILURE:
            return {
                takingCarManagement: {
                    ...state.takingCarManagement,
                    savePending: false,
                    saveSuccess: null,
                    saveError: action.data
                }
            }
        default:
            return state
    }
}